var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flashes"},_vm._l((_vm.alerts),function(alert,index){return _c('flash',{key:index,attrs:{"level":alert.level,"message":alert.message},on:{"close":function($event){return _vm.$delete(_vm.alerts, index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }